import React from "react";
import styles from "./TheComparison.module.css";
import HeaderBar from "../HeaderBar/HeaderBar";
import AnimatedButton from "../AnimatedButton/AnimatedButton";

const Card = ({ title, items, variant }) => {
    return (
        <div
            className={`${styles.card} ${variant === "danger" ? styles.dangerCard : ""
                }`}
        >
            <div className={styles.cardHeader}>
                <h4>{title}</h4>
                <div className={styles.line}></div>
            </div>

            <ul className={styles.list}>
                {items.map((item, index) => (
                    <li key={index} className={styles.listItem}>
                        <span className={styles.dot}></span>
                        {item}
                    </li>
                ))}
            </ul>
        </div>
    );
};
// NITISH
const TheComparison = () => {
    return (
        <div className={styles.containerBox}>
            <div className={styles.Forsticky}>
                <HeaderBar title="The Comparison" />
            </div>

            <div className={styles.container}>
                <h2 className={styles.mainTitle}>
                    How businesses usually handle calls
                </h2>

                <Card
                    title="ANSWERING CALLS YOURSELF"
                    items={[
                        "Interrupts your work",
                        "Easy to miss calls",
                        "Hard to scale",
                    ]}
                />

                <Card
                    title="HUMAN RECEPTIONIST"
                    items={[
                        "Reliable, but expensive",
                        "$1,500–$4,500/month",
                        "Limited availability",
                    ]}
                    variant="danger"
                />

                <Card
                    title="IVR / PHONE MENU"
                    items={[
                        "Low cost",
                        "Frustrates callers",
                        "Loses opportunities",
                    ]}
                />
                <p className={styles.lastDesc}>There’s a simpler way to handle business calls.</p>
            </div>
            <AnimatedButton label="Continue" />
        </div>
    );
};

export default TheComparison;
